<script setup>
  import { useLayoutStore } from '@/features/layout/useLayoutStore.js'
  import { useClubRouter } from '@/features/router/useClubRouer.js'
  import VersionText from '@/features/versioning/VersionText.vue'

  const layoutStore = useLayoutStore()

  const router = useClubRouter()
  function handleClickBackToAdmin() {
    router.push(`${window.location.host}/admin`)
  }
</script>

<template>
  <footer class="sidebar-panel-footer">
    <Button
      v-if="false"
      severity="secondary"
      label="Back to Admin"
      icon="pi pi-arrow-left"
      @click="handleClickBackToAdmin"
    />

    <RouterLink to="/">
      <img :src="layoutStore.footerLogoSrc" alt="logo" class="logo" />
    </RouterLink>

    <VersionText />
  </footer>
</template>

<style lang="scss" scoped>
  footer.sidebar-panel-footer {
    padding: 16px;
    display: flex;
    gap: 20px;
    grid-area: footer;
    border-top: 1px solid var(--fm-ui-sidebar-inner-border);
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .logo {
    max-width: 175px;
  }
</style>
